
export class Auth {
  originContext?: string;
  authorizationContext?: string;
  origin?: string;
  authorization?: string;
  bypass?: string;
  cnes?: string;
  cnsProfissional?: string;
  cnsPaciente?: string;


  constructor(data?) {
    if (data) {
      this.originContext = data.originContext;
      this.authorizationContext = data.authorizationContext;
      this.origin = data.origin;
      this.authorization = data.authorization;
      this.bypass = data.bypass;
      this.cnes = data.cnes;
      this.cnsProfissional = data.cnsProfissional;
      this.cnsPaciente = data.cnsPaciente;
    }
  }

  public static fromDTO?(data) {
    const auth = new Auth();
    auth.originContext = data.originContext;
    auth.authorizationContext = data.authorizationContext;
    auth.origin = data.origin;
    auth.authorization = data.authorization;
    auth.bypass = data.bypass;
    auth.cnes = data.cnes;
    auth.cnsProfissional = data.cnsProfissional;
    auth.cnsPaciente = data.cnsPaciente;

    return auth;
  }

  public toDTO?() {
    const dto: any = {};
    dto.originContext = this.originContext;
    dto.authorizationContext = this.authorizationContext;
    dto.origin = this.origin;
    dto.authorization = this.authorization;
    dto.bypass = this.bypass;
    dto.cnes = this.cnes;
    dto.cnsProfissional = this.cnsProfissional;
    dto.cnsPaciente = this.cnsPaciente;

    return dto;
  }

}
